<template>
  <section>
    <div class="mb-4">
      <router-link to="/user/listings" class="text-primary-link">
        {{ $t('message.menu.my_listings') }}
      </router-link> <i class="far fa-chevron-right small"></i> {{ title }}
    </div>
    <listing-form/>
  </section>
</template>

<script>
  import listingForm from './ListingForm'

  export default {
    components: {
      listingForm
    },
    data () {
      return {
        title: null
      }
    },
    mounted () {
      this.title = this.$i18n.t('message.menu.add_listing')
      if (this.$route.params.id) {
        this.title = this.$i18n.t('message.menu.edit_listing')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/user/listing/ManageUserListing.vue